module.exports = __webpack_public_path__ + "static/media/logo.76c7b5b1.svg";